import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {INotificacion, IParcela} from "../../../types";
import {Paper, Typography, Button, TextField} from "@material-ui/core";

import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";
import {Image} from "@material-ui/icons";


const config = require('../../../config.json');
const texts = require('../../../texts/subirdatos.json');


interface IProps {
    notify(notification: INotificacion): void
    openNotificacionDialog(callback: string): void
    setCargando(cargando: boolean): void
    menu: boolean
    parcela: IParcela
    idioma: string
}

interface Istate {
    rgb: any
    lst: any
    ndvi: any
    fecha: string
    subiendo: string[]
    hora: string
    pistola_blanco: number
    pistola_negro: number
    dron_blanco: number
    dron_negro: number
    text: Record<string, string>
}

class ETcData extends React.Component<IProps, Istate> {

    state:Istate = {
        rgb: 0,
        lst: 0,
        ndvi: 0,
        fecha: '',
        subiendo: [] as string[],
        hora: '12:00',
        pistola_blanco: 0,
        pistola_negro: 0,
        dron_blanco: 0,
        dron_negro: 0,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    sleep = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    handleFile(e: any, type: string) {
        switch (type) {
            case 'rgb':
                this.setState({rgb: e.target.files[0]})
                return
            case 'lst':
                this.setState({lst: e.target.files[0]})
                return
            case 'ndvi':
                this.setState({ndvi: e.target.files[0]})
                return
            default:
                return
        }
    }

    handleClick = async () => {
        type Iprod = 'rgb' | 'lst' | 'ndvi'
        let contador = 0
        for (const element of ['rgb', 'lst', 'ndvi']) {
            this.props.setCargando(true)
            contador += 1
            if (this.state[element as Iprod] === 0 || this.state[element as Iprod] === undefined) continue
            let subiendo = this.state.subiendo
            subiendo.push(element)
            this.setState({subiendo: subiendo})
            const data = new FormData();
            data.append('file', this.state[element as keyof Istate]);
            const nombre = element+'.tif'
            axios.post(
                config.url+`/file/upload?nombre=${nombre}&fecha=${this.state.fecha}&parcela=${this.props.parcela.id}&hora=${this.state.hora}&pistola_b=${this.state.pistola_blanco}&pistola_n=${this.state.pistola_negro}&dron_b=${this.state.dron_blanco}&dron_n=${this.state.dron_negro}`,
                data,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }
                })
                .then(() => {
                    let s = []
                    for (const e of this.state.subiendo) {
                        if (e !== element) s.push(e)
                    }
                    this.setState({subiendo: s})
                    if (contador === 3) this.props.setCargando(false)
                    this.props.notify({message: 'Datos enviados correctamente', variant: 'success'})
                    this.setState({
                        rgb: 0,
                        lst: 0,
                        ndvi: 0,
                        fecha: '',
                        subiendo: [] as string[],
                        hora: '12:00',
                        pistola_blanco: 0,
                        pistola_negro: 0,
                        dron_blanco: 0,
                        dron_negro: 0,
                    })
                })
                .catch(() => {
                    this.props.notify({message: 'Error interno al enviar los rasters al backend', variant: 'error'})
                })
        }
    }

    todoListo = (): boolean => {
        if (this.state.pistola_negro === null) return true
        if (this.state.pistola_blanco === null) return true
        if (this.state.dron_negro === null) return true
        if (this.state.dron_blanco === null) return true
        if (this.state.ndvi === 0) return true
        if (this.state.lst === 0) return true
        if (this.state.fecha.length === 0) return true
        return false
    }


    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    height: '100%'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        marginTop: 20,
                        marginLeft: 20,
                        marginBottom: 30,
                        fontSize: 18,
                        fontWeight: "bold",
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["1"]}
                </Typography>

                <Typography
                    style={{
                        marginTop: 10,
                        marginLeft: 30,
                        marginBottom: 30,
                        fontSize: 16,
                        fontFamily: "Poppins"
                    }}
                >
                    <b>* {this.state.text["23"]}</b>:
                    <dl style={{marginLeft: 20, fontSize: 14}}>
                        <li>
                            {this.state.text["2"]}
                        </li>
                        <li>
                            {this.state.text["3"]}
                        </li>
                        <li>
                            {this.state.text["4"]}
                        </li>
                        <li>
                            {this.state.text["5"]}
                        </li>
                    </dl>
                </Typography>


                <form
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: '80%',
                        alignItems: "flex-start",
                        marginLeft: 30
                    }}
                >
                    <TextField
                        style={{
                            width: 250,
                            fontFamily: "Poppins"
                        }}
                        label={this.state.text["6"]}
                        type="date"
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={this.state.fecha}
                        onChange={(e) => {
                            this.setState({fecha: e.target.value})
                        }}
                    />


                    <TextField
                        style={{
                            width: 150,
                            marginLeft: 100,
                            fontFamily: "Poppins"
                        }}
                        label={this.state.text["6"]}
                        id="time"
                        type="time"
                        value={this.state.hora}
                        onChange={e => {
                            this.setState({hora: e.target.value})
                        }}
                    />

                </form>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 30
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: 30,
                        alignItems: "center"
                    }}>
                        <input
                            accept="image/tiff"
                            style={{
                                display: 'none',
                                fontFamily: "Poppins"
                            }}
                            id="raised-button-rgb"
                            type="file"
                            onChange={(e) => this.handleFile(e, 'rgb')}
                        />
                        <label htmlFor="raised-button-rgb">
                            <Button
                                component="span"
                                variant={"contained"}
                                color={"primary"}
                                style={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    fontFamily: "Poppins",
                                    width: 170
                                }}
                            >
                                {this.state.text["8"]}
                            </Button>
                        </label>
                        <Typography
                            style={{
                                marginLeft: 20,
                                color: this.state.rgb === 0 || this.state.rgb === undefined? "#666666" : "#80ED99",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.rgb === 0 || this.state.rgb === undefined?
                                this.state.text["9"]
                                :
                                this.state.rgb.name
                            }
                        </Typography>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: 10,
                        alignItems: "center"
                    }}>
                        <input
                            accept="image/tiff"
                            style={{
                                display: 'none',
                                fontFamily: "Poppins"
                            }}
                            id="raised-button-lst"
                            type="file"
                            onChange={(e) => this.handleFile(e, 'lst')}
                        />
                        <label htmlFor="raised-button-lst">
                            <Button
                                component="span"
                                variant={"contained"}
                                color={"primary"}
                                style={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    width: 170,
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["10"]}
                            </Button>
                        </label>
                        <Typography
                            style={{
                                marginLeft: 20,
                                color: this.state.lst === 0 || this.state.lst === undefined? "#666666" : "#80ED99",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.lst === 0 || this.state.lst === undefined?
                                this.state.text["9"]
                                :
                                this.state.lst.name
                            }
                        </Typography>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: 10,
                        alignItems: "center"
                    }}>
                        <input
                            accept="image/tiff"
                            style={{
                                display: 'none',
                                fontFamily: "Poppins"
                            }}
                            id="raised-button-ndvi"
                            type="file"
                            onChange={(e) => this.handleFile(e, 'ndvi')}
                        />
                        <label htmlFor="raised-button-ndvi">
                            <Button
                                component="span"
                                variant={"contained"}
                                color={"primary"}
                                style={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    width: 170,
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["11"]}
                            </Button>
                        </label>
                        <Typography
                            style={{
                                marginLeft: 20,
                                color: this.state.ndvi === 0 || this.state.ndvi === undefined? "#666666" : "#80ED99",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.ndvi === 0 || this.state.ndvi === undefined?
                                this.state.text["9"]
                                :
                                this.state.ndvi.name
                            }
                        </Typography>
                    </div>
                </div>



                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 450,
                        marginTop: 40,
                        marginLeft: 30
                    }}
                >
                    <div
                        style={{
                            width: 150,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderTopColor: '#eee',
                            borderLeftColor: '#eee'
                        }}
                    />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["12"]}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["13"]}
                        </Typography>
                    </div>

                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 450,
                        marginLeft: 30
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderTopWidth: 0
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["14"]}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0,
                            borderTopWidth: 0
                        }}
                    >
                        <TextField
                            style={{
                                width: 100,
                                fontFamily: "Poppins"
                            }}
                            value={this.state.pistola_blanco}
                            onChange={e => this.setState({pistola_blanco: parseFloat(e.target.value)})}
                            id="pistola_blanco"
                            type="number"
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0,
                            borderTopWidth: 0
                        }}
                    >
                        <TextField
                            style={{
                                width: 100,
                                fontFamily: "Poppins"
                            }}
                            value={this.state.dron_blanco}
                            onChange={e => this.setState({dron_blanco: parseFloat(e.target.value)})}
                            id="dron_blanco"
                            type="number"
                        />
                    </div>

                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 450,
                        marginLeft: 30
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderTopWidth: 0
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["15"]}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0,
                            borderTopWidth: 0
                        }}
                    >
                        <TextField
                            style={{
                                width: 100,
                                fontFamily: "Poppins"
                            }}
                            value={this.state.pistola_negro}
                            onChange={e => this.setState({pistola_negro: parseFloat(e.target.value)})}
                            id="pistola_negro"
                            type="number"
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 150,
                            height: 40,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderLeftWidth: 0,
                            borderTopWidth: 0
                        }}
                    >
                        <TextField
                            style={{
                                width: 100,
                                fontFamily: "Poppins"
                            }}
                            value={this.state.dron_negro}
                            onChange={e => this.setState({dron_negro: parseFloat(e.target.value)})}
                            id="dron_negro"
                            type="number"
                        />
                    </div>
                </div>

                <Button
                    variant={"contained"}
                    color={"primary"}
                    disabled={this.todoListo()}
                    style={{
                        width: 450,
                        marginTop: 40,
                        marginLeft: 30
                    }}
                    onClick={() => this.handleClick()}
                >
                    <Typography
                        style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["16"]}
                    </Typography>
                </Button>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    parcela: state.subirDatos.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    openNotificacionDialog: (callback: string) => dispatch({type: "open-nota-dialog", callback}),
    setCargando: (cargando: boolean) => dispatch({type: "cargando", cargando})
});

export default connect(mapStateToProps, mapDispatchToProps)(ETcData);
